/* eslint-disable */
import React, { useEffect, useState, } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Acl } from 'modules/common/components/Acl';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
import { getJson } from 'session';
import * as actions from '../action';
import * as c from '../constant';

function EmployeeUserManagementContent({
  handleAddModal,
  handleChangePassword,
  handleEdit,
  userManagementId,
  showUserManagement,
  userManagementInfo,
  handleActivateModal,
  handleDeactivateModal,
  handleResetPasswordModal
}) {
  const [permissions, setPermissions] = useState([]);

  useEffect(() => {
    setPermissions(getJson('permissions'));
  }, []);
  useEffect(() => {
    if (_.isEmpty(userManagementId)) return;
    showUserManagement(userManagementId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(userManagementId)) return;
    showUserManagement(userManagementId);
  }, [userManagementId]);

  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex justify-content-end">
          {Acl(permissions, ['CREATE ADMIN ACCOUNT']) && (
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4"
            >
              Add&nbsp;
              <i className="fas fa-plus" />
            </button>
          )}
        </div>
      </div>
      {!_.isEmpty(userManagementInfo) ? (
        <React.Fragment>
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Personal Information</h3>
                <div>
                  {Acl(permissions, ['ACTIVATE ADMIN ACCOUNT']) &&
                    !_.get(userManagementInfo, 'attributes.is_active') ? (
                    <button
                      type="button"
                      onClick={handleActivateModal(userManagementInfo)}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-2"
                    >
                      Activate
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={handleDeactivateModal(userManagementInfo)}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-2"
                    >
                      Deactivate
                    </button>
                  )}
                  {Acl(permissions, ['UPDATE ADMIN ACCOUNT']) && (
                    <button
                      type="button"
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-2"
                      onClick={handleEdit(userManagementInfo)}
                    >
                      Update
                    </button>
                  )}
                  {Acl(permissions, ['RESET ADMIN PASSWORD']) &&
                    _.get(userManagementInfo, 'attributes.is_active') ? (
                    <button
                      type="button"
                      onClick={handleResetPasswordModal(userManagementInfo)}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-2"
                    >
                      Reset Password
                    </button>
                  ) : ''}
                </div>
              </div>
              <hr />
              <div className="mt-4">
                <div className="row d-flex justify-content-center">
                  <div className="col-4">
                    <img
                      className="w-100 rounded"
                      src={
                        !_.isObject(
                          _.get(userManagementInfo, 'attributes.photo') || ''
                        )
                          ? _.get(userManagementInfo, 'attributes.photo') ||
                          ImagePlaceholder
                          : _.get(userManagementInfo, 'photo.cdnUrl') ||
                          ImagePlaceholder
                      }
                      alt=""
                    />
                  </div>
                  <div className="col">
                    <table className="table table-striped table-borderless">
                      <tbody>
                        <tr>
                          <th className="table-title">First Name:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.first_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Last Name:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.last_name'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Email Address:</th>
                          <td>
                            {_.get(userManagementInfo, 'attributes.email') ||
                              '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Mobile Number:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.mobile_number'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Telephone Number:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.telephone_number'
                            ) || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Status:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'attributes.is_active'
                            ) ? 'Active' : 'Inactive' || '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Address:</th>
                          <td>
                            {_.get(userManagementInfo, 'attributes.address') ||
                              '--'}
                          </td>
                        </tr>
                        <tr>
                          <th className="table-title">Role:</th>
                          <td>
                            {_.get(
                              userManagementInfo,
                              'included.roles.attributes.name'
                            ) || '--'}
                          </td>
                        </tr>
                        {Acl(permissions, ['CHANGE ADMIN PASSWORD']) && (
                          <tr>
                            <th className="table-title">Password:</th>
                            <td>
                              <button
                                type="button"
                                className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-sm"
                                onClick={handleChangePassword(
                                  userManagementInfo
                                )}
                              >
                                Change Password
                              </button>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div className="d-flex align-items-center justitfy-content-center h-100">
          <div className="text-center mx-auto py-4">
            <img
              src={emptyStateImage}
              className="img-responsive image-wrapper mb-4 mt-3"
              alt="Empty State"
            />
            <p className="emp-title mb-0"> No Item Found </p>
          </div>
        </div>
      )}
    </div>
  );
}

EmployeeUserManagementContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleChangePassword: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  showUserManagement: PropTypes.instanceOf(Function).isRequired,
  userManagementInfo: PropTypes.instanceOf(Object).isRequired,
  userManagementId: PropTypes.string.isRequired,
  handleActivateModal: PropTypes.instanceOf(Function).isRequired,
  handleDeactivateModal: PropTypes.instanceOf(Function).isRequired
};

const mapStateToProps = ({ api }, { match }) => ({
  userManagementInfo: _.get(api, `${c.GET_SINGLE_USER_MANAGEMENT}.item`) || {},
  userManagementId: _.get(match, 'params.userManagementId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(EmployeeUserManagementContent);
